import GTEestiRegularWOFF from "./fonts/GT-Eesti-Display-Regular.woff";

import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        type: "light",
        primary: {
            main: "#E16C52",
            contrast: "#9C331C"
        },
        secondary: {
            main: "#E7AA67",
        },
        background: {
            default: "#222222",
            switch: '#555555'
        },
        text: {
            primary: "#ffffff",
            contrast: "#000000",
            darker: "#f2f2f2",
            logo: "#222222"
        },
        contrast: {
            main: "#9C331C"
        }
    },
    typography: {
        fontFamily: [
            "GT Eesti Display",
            "Arial",
            "Helvetica",
            "sans-serif",
        ].join(","),
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-family: 'GT Eesti Display';
                    font-style: normal;
                    font-display: swap;
                    font-weight: normal;
                    src: url(${GTEestiRegularWOFF}) format('woff');
                },
            `,
        },
    },
    breakpoints: {
        values: {
            start: 0,
            lg: 1200,
            xl: 2600
        }
       
    }
});
